module.exports = __webpack_public_path__ + "static/media/expii1.755ea9bb.jpg";